import { render, staticRenderFns } from "./DesktopMenu.vue?vue&type=template&id=566246cb&scoped=true"
import script from "./DesktopMenu.vue?vue&type=script&lang=js"
export * from "./DesktopMenu.vue?vue&type=script&lang=js"
import style0 from "./DesktopMenu.vue?vue&type=style&index=0&id=566246cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566246cb",
  null
  
)

export default component.exports